import { HeaderActionButton } from '@/contracts/Settings'
import { YmAttrs } from '@/contracts/Ym'

export type HeaderNextButtonData = {
  url: string
  label: string
  icon: string
  ymEvent: YmAttrs | null
}

const ACCENT_LABEL = 'Страховой случай'

export const isAccentLabel = (label: string): boolean => label === ACCENT_LABEL

const getIcon = (icon: HeaderActionButton['icon']): string => {
  if (typeof icon === 'string') return icon
  if (Array.isArray(icon)) return icon[0]?.url ?? ''
  return ''
}

const getYmEvent = (ymEvent: HeaderActionButton['ymEvent']): YmAttrs | null =>
  ymEvent?.ymMethod ? ymEvent : null

export const mapHeaderButtons = (
  buttons: ReadonlyArray<HeaderActionButton> | undefined
): HeaderNextButtonData[] => {
  if (!Array.isArray(buttons)) return []

  return buttons.map((button) => ({
    url: button?.url ?? '',
    label: button?.label ?? '',
    icon: getIcon(button?.icon),
    ymEvent: getYmEvent(button?.ymEvent),
  }))
}

type YmWindow = Window & { ym?: (...args: unknown[]) => void }

export const sendYmEvent = (
  ymEvent: YmAttrs | null,
  defaultYmId: string | number
): void => {
  const { ym } = window as YmWindow

  if (!ymEvent || !ym) return

  ym(ymEvent.ymId || defaultYmId, ymEvent.ymMethod, ymEvent.ymTarget)
}

export type HeaderModalKey = 'navigation' | 'auth-account'

const MODAL_KEYS: HeaderModalKey[] = ['navigation', 'auth-account']

const URL_PARSE_BASE = 'http://base.invalid'

export const getModalKey = (url: string): HeaderModalKey | null => {
  if (!url) return null

  let value: string | null

  try {
    value = new URL(url, URL_PARSE_BASE).searchParams.get('invokeModal')
  } catch {
    return null
  }

  return MODAL_KEYS.find((key) => key === value) ?? null
}
